module.exports = __webpack_public_path__ + "img/elantra-n-25.3a89815f.png";